<input
  #phoneInput
  name="profile[phone_number]"
  autocomplete="tel"
  type="tel"
  (keypress)="preventNonNumberInput($event)"
  autofocus
/>
